import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr";
flatpickr.localize(French);

import { dictionnaire } from "../i18n/fr";

const devises = {
  USD: { d: 2, symbol: "$", country: "en-US", name: "US Dollar" },
  EUR: { d: 2, symbol: "€", country: "fr-FR", name: "Euro" },
  GBP: { d: 2, symbol: "£", country: "en-GB", name: "British Pound Sterling" },
  HKD: { d: 2, symbol: "HK$", country: "en-HK", name: "Hong Kong Dollar" },
  JPY: { d: 0, symbol: "JPY", country: "ja-JP", name: "Japanese Yen" },
  CNY: { d: 0, symbol: "CNY", country: "zh-CN", name: "Chinese Yuan" },
  CHF: { d: 2, symbol: "CHF", country: "de-CH", name: "Swiss Franc" },
};

const formatCurrency = (number, devise) => {
  const country = devises[devise].country;
  return number
    ? new Intl.NumberFormat(country, {
        style: "currency",
        currency: devise,
      }).format(number)
    : "";
};

class B2bTraduction {
  /**
   * retourne la traduction d'un libellé à partir d'une clé du genre url
   * @param {String} key     clé de recherche : /linelist/edit/button
   * @param {String} prefixe si le chemin est relatif (ne commence pas par un / )
   * @returns String traduction
   */
  static traduit(key, prefixe) {
    const keys = key.split("/");
    let o;
    if (!keys[0]) {
      keys.shift();
      o = dictionnaire;
    } else {
      o = dictionnaire[prefixe];
    }
    //
    while (keys.length) {
      if (!o) return B2bTraduction.erreur(key);
      const k = keys.shift();
      if (!k) return B2bTraduction.erreur(key);
      o = o[k];
    }
    return o || B2bTraduction.erreur(key);
  }
  static erreur(p) {
    return `???${p}`;
  }

  static toDate(value) {
    if (!value) return "";
    let a = flatpickr.parseDate(value, "Ymd");
    if (!a) return "";
    const month = a.toLocaleString("fr-FR", { month: "short" });
    return `${a.getDate()} ${month} ${a.getFullYear()}`;
  }

  static toDateTime(value) {
    if (!value) return "";
    let date;
    // Si c'est un format Ymd (ex: "20251215"), on le parse manuellement
    if (typeof value === "string" && /^\d{8}$/.test(value)) {
      const y = value.slice(0, 4);
      const m = value.slice(4, 6);
      const d = value.slice(6, 8);
      date = new Date(`${y}-${m}-${d}`);
    } else {
      date = new Date(value);
    }
    if (isNaN(date)) return "";
    const day = date.getDate();
    const month = date.toLocaleString("fr-FR", { month: "short" });
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day} ${month} ${year} ${hours}:${minutes}`;
  }

  static timeAgo(value) {
    if (!value) return "";
    const date = new Date(value);
    if (isNaN(date)) return "";
    const now = new Date();
    const diff = now - date;
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (years > 0) return `Il y a ${years} an${years > 1 ? "s" : ""}`;
    if (months > 0) return `Il y a ${months} mois`;
    if (days > 0) return `Il y a ${days} jour${days > 1 ? "s" : ""}`;
    if (hours > 0) return `Il y a ${hours} heure${hours > 1 ? "s" : ""}`;
    if (minutes > 0) return `Il y a ${minutes} minute${minutes > 1 ? "s" : ""}`;
    return "À l'instant";
  }
}

const traduit = B2bTraduction.traduit;
const toDate = B2bTraduction.toDate;
const toDateTime = B2bTraduction.toDateTime;
const timeAgo = B2bTraduction.timeAgo;

const flatpickrConfig = {
  altInput: true,
  altFormat: "j F Y",
  dateFormat: "Ymd",
  allowInput: true,
};

export {
  flatpickrConfig,
  formatCurrency,
  timeAgo,
  toDate,
  toDateTime,
  traduit
};

